import { Space } from 'antd';
import styled from 'styled-components';

export const FormatFieldWrapper = styled(Space)`
	width: 100%;
	margin-bottom: 1.125rem;
`;
